module.exports = __webpack_public_path__ + "static/ELCO_Scroll_Beta_Desktop-3aa681d3eb6d3e2bbef9396222eab550.mp4";